module.exports = __webpack_public_path__ + "img/sign_background.ded6ae37.png";